// ==============================================================================
// Centralized PBX Target Configuration (Frontend)
// ==============================================================================
// To switch between environments, update PBX_HOST below:
// - Public Domain: "89.147.153.83:8089" (Commented out)
// - Secured Office Network: "10.147.36.200:8089" (Active)
// ==============================================================================

// export const PBX_HOST = process.env.REACT_APP_PBX_HOST || "89.147.153.83:8089";
export const PBX_HOST = process.env.REACT_APP_PBX_HOST || "10.147.36.200:8089";
export const PBX_BASE_URL = process.env.REACT_APP_PBX_BASE_URL || `https://${PBX_HOST}`;
export const PBX_DIRECT_URL = `${PBX_BASE_URL}/api`;
export const PBX_REC_BASE_URL = `${PBX_BASE_URL}/rec`;
